import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { SERVERADDRESS } from "../constants";
import { useParams } from "react-router-dom";
import moment from "moment";
import { getAllDrivers } from "../actions/userActions";
import { updateOrderById } from "../actions/orderActions";
// import { getAllOrders, setOrderData } from "../actions/orderActions";
// import { NavLink } from "react-router-dom";
// import { paginationDataToShow } from "../actions/generalActions";
// import AdminOrderListRow from "../components/adminOrder/AdminOrderListRow";

const AdminOrderDetailPage = ({ current }) => {
  const categories = useSelector((state) => state.categories);
  const auth = useSelector((state) => state.auth);
  const users = useSelector((state) => state.users);
  const subCategories = useSelector((state) => state.subCategories);
  const store = useSelector((state) => state.store);
  const orders = useSelector((state) => state.orders);
  const items = useSelector((state) => state.items);
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);
  // console.log(current, "current2");
  // console.log(orders.orderDetails, "orderDetails");
  const params = useParams();
  const orderData = async () => {
    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/order/getOrderById`,
      { _id: params.id }
    );
    setDetails(data);
    if (data?.driverId) {
      setValues({ ...values, driverId: data?.driverId });
    }
    console.log(data, "datadata");
  };
  const userData = async (e) => {
    dispatch(getAllDrivers());
  };
  const [values, setValues] = useState({
    status: "",
    driverId: "",
  });
  console.log(values);
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = { ...values };
    for (let key of Object.keys(data)) {
      if (data[key] === "") {
        delete data[key];
      }
    }
    console.log("Submitting update with:", {
      ...data,
      role: auth?.user?.role,
    });
    if (data?.driverId) {
      dispatch(
        updateOrderById({
          _id: details?.id,
          driverId: data?.driverId,
          role: auth?.user?.role,
        })
      );
    }
    if (data?.status) {
      dispatch(
        updateOrderById({
          _id: details?.id,
          status: data?.status,
          role: auth?.user?.role,
        })
      );
    }
  };
  useEffect(() => {
    orderData();
    userData();
  }, []);
  // useEffect(() => {
  //   dispatch(
  //     setOrderData({
  //       ...orders,
  //       current,
  //       _id: order.id,
  //     })
  //   );
  // }, []);
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Orders Details</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          {/* <button className="btn btn-success">
                            Export as CSV
                          </button> */}
                          {/* <button className="btn btn-warning">Print</button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row mx-2 my-2">
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className="form-group"
                            style={{ display: "flex" }}
                          >
                            <strong htmlFor="fName">Order #: </strong>
                            <div type="text">&nbsp; {details?.orderNo}</div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="form-group"
                            style={{ display: "flex" }}
                          >
                            <strong htmlFor="fName">Date: </strong>
                            {/* <div type="text">
                              &nbsp;
                              {moment(details?.date).format("LLLL")}
                            </div> */}
                            <div type="text">
                              &nbsp;
                              {moment(details?.date).format(
                                "dddd, MMMM D, YYYY"
                              ) +
                                " - " +
                                moment(details?.date).format("h:mm A")}
                            </div>
                          </div>
                        </div>
                        {auth?.user?.role === "superAdmin" && (
                          <>
                            <div className="col-md-6">
                              <div
                                className="form-group"
                                style={{ display: "flex" }}
                              >
                                <strong htmlFor="fName">Store Name: </strong>
                                <div type="text">
                                  &nbsp; {details?.storeId?.name}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div
                                className="form-group"
                                style={{ display: "flex" }}
                              >
                                <strong htmlFor="fName">Customer Name: </strong>
                                <div type="text">
                                  &nbsp;{" "}
                                  {details?.userId?.firstName +
                                    " " +
                                    details?.userId?.lastName}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div
                                className="form-group"
                                style={{ display: "flex" }}
                              >
                                <strong htmlFor="fName">Phone: </strong>
                                <div type="text">
                                  &nbsp; {details?.userId?.phone}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div
                                className="form-group"
                                style={{ display: "flex" }}
                              >
                                <strong htmlFor="fName">Email: </strong>
                                <div type="text">
                                  &nbsp; {details?.userId?.email}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div
                                className="form-group"
                                style={{ display: "flex" }}
                              >
                                <strong htmlFor="fName">
                                  Delivery Address:{" "}
                                </strong>
                                {/* <div type="text">&nbsp; Home - </div> */}
                                <br />
                                <p type="text">
                                  &nbsp; {details?.address?.address}
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-12 mx-2 my-2">
                          <div
                            className="form-group"
                            style={{
                              display: "flex",
                              backgroundColor: "lightgray",
                              padding: "3px",
                            }}
                          >
                            <strong htmlFor="fName">
                              <h4>Order:</h4>{" "}
                            </strong>
                          </div>
                          {details?.itemsId?.length > 0 &&
                            details?.itemsId?.map((current, i) => {
                              return (
                                <ul className="order-items">
                                  <li>
                                    {/* Himalaya Rich Soap - 150 grams{" "} */}
                                    {current?.name
                                      ? current?.name
                                      : `Product ${i + 1}`}{" "}
                                    <span>
                                      {current?.sellPrice} $ | x{" "}
                                      {current?.quantity}
                                    </span>
                                  </li>
                                </ul>
                              );
                            })}
                          {/* //   <li>
                          //     Mother's Horlicks - 500 grams 600 ${" "}
                          //     <span>x 1</span>
                          //   </li>
                          //   <li>
                          //     Himalaya Rich Soap - 150 grams{" "}
                          //     <span>60 $ | x 2</span>
                          //   </li>
                          //   <li>
                          //     Himalaya Rich Soap - 150 grams{" "}
                          //     <span>60 $ | x 2</span>
                          //   </li>
                          // </ul> */}
                          <div className="order-details">
                            <p>
                              Order Item Total{" "}
                              <span>{details?.totalAmount} $</span>
                            </p>
                            {/* <p>
                              Order Delivery Charge <span>0 $</span>
                            </p>
                            <p>
                              Split Order Tax <span>0 $</span>
                            </p>
                            <p>
                              Split Order Discount <span>- 0 $</span>
                            </p>
                            <p>
                              Split Order Wallet Discount <span>- 0 $</span>
                            </p> */}
                            <p className="amount-to-collect">
                              AMOUNT TO COLLECT{" "}
                              <span>{details?.totalAmount} $</span>
                            </p>
                          </div>
                          <h5>Order Tracking</h5>
                          <div className="tracking-list">
                            {details?.actions?.length > 0 &&
                              details?.actions?.map((current, i) => {
                                return (
                                  <>
                                    <div className="tracking-item" key={i}>
                                      <div className="icon"></div>
                                      <div className="tracking-details">
                                        <p className="date">
                                          {moment(current?.time).format("LLL")}
                                        </p>
                                        <p className="status">
                                          {current?.details}
                                        </p>
                                      </div>
                                    </div>
                                    {i === details?.actions?.length - 1 && (
                                      <div></div>
                                    )}
                                  </>
                                );
                              })}
                            {/* <div className="tracking-item">
                              <div className="icon"></div>
                              <div className="tracking-details">
                                <p className="date">Jan 11, 2025 9:29 AM</p>
                                <p className="status">Order Created</p>
                              </div>
                            </div>
                            <div className="tracking-item">
                              <div className="icon"></div>
                              <div className="tracking-details">
                                <p className="date">Jan 11, 2025 9:42 AM</p>
                                <p className="status">
                                  Order accepted by Walmart
                                </p>
                              </div>
                            </div>
                            <div className="tracking-item">
                              <div className="icon"></div>
                              <div className="tracking-details">
                                <p className="date">Jan 15, 2025 5:34 PM</p>
                                <p className="status">
                                  Order ongoing by Walmart
                                </p>
                              </div>
                            </div>
                            <div className="tracking-item">
                              <div className="icon"></div>
                              <div className="tracking-details">
                                <p className="date">Jan 24, 2025 3:36 PM</p>
                                <p className="status">Order ongoing</p>
                              </div>
                            </div>
                            <div className="tracking-item">
                              <div className="icon"></div>
                              <div className="tracking-details">
                                <p className="date">Jan 29, 2025 10:41 PM</p>
                                <p className="status">
                                  Order delivered by Walmart
                                </p>
                              </div>
                            </div>
                            <div className="tracking-item">
                              <div className="icon"></div>
                              <div className="tracking-details">
                                <p className="date">Jan 29, 2025 10:41 PM</p>
                                <p className="status">
                                  Order refunded by administrator
                                </p>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card-footer"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {auth?.user?.role === "admin" && (
                      <>
                        <div className="col-sm-8">
                          <form>
                            <select
                              onChange={handleChange("status")}
                              value={values.status}
                              className="form-select"
                            >
                              <option value="" selected disabled>
                                Select Status
                              </option>
                              {details?.status === "Pending" && (
                                <>
                                  <option value="Accept">Accept</option>
                                  <option value="Decline">Decline</option>
                                </>
                              )}
                              {details?.status !== "Accept" ||
                                (details?.status !== "Decline" && (
                                  <option value="Ready to dispatch">
                                    Ready to dispatch
                                  </option>
                                ))}
                            </select>
                          </form>
                        </div>
                        <div className="col-auto">
                          <button
                            onClick={handleSubmit}
                            className="btn btn-primary"
                          >
                            Update Status
                          </button>
                        </div>
                      </>
                    )}
                    {auth?.user?.role === "superAdmin" && (
                      <>
                        <div className="col-sm-8">
                          {users?.allDrivers?.length > 0 && (
                            <form>
                              <select
                                className="form-select"
                                onChange={handleChange("driverId")}
                                value={values.driverId}
                              >
                                <option value="" disabled>
                                  Select Driver
                                </option>

                                {users.allDrivers.map((driver) => (
                                  <option key={driver.id} value={driver.id}>
                                    {driver.firstName} {driver.lastName}
                                  </option>
                                ))}
                              </select>
                            </form>
                          )}
                        </div>
                        <div className="col-auto">
                          <button
                            onClick={handleSubmit}
                            className="btn btn-primary"
                          >
                            Select Driver
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminOrderDetailPage;
